<template>
  <div class="container-fluid">
    <!-- <div class="row">
      <div class="col-md-12 mb-3 px-0">
        <div class="text-primary c-pointer px-0 col-md-2 mt-2" @click="previousPage">
          <el-button class="text-primary" plain>
            <el-icon>
              <DArrowLeft />
            </el-icon> Back
          </el-button>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-12 px-0 mt-3">
        <div v-if="workflows.length > 0">
          <TableSearch
            :data="filteredData"
            :headers="headers"
            @update:searchText="handleSearchTextUpdate"
            :checkMultipleItem="false"
            :filterItem="false"
            @checkedrow="handleSelectionChange"
            v-loading="loading"
          >
            <template v-slot:name="{ item }">
              <div class="c-pointer">
                <router-link
                  class="text-decoration-none text-dak fw-500"
                  :to="`/tenant/workflow/add?workflowId=${item.id}&fw=true`"
                >
                  {{ item.name }}
                </router-link>
              </div>
            </template>
            <template v-slot:isActive="{ item }">
              <div class="c-pointer">
                <router-link
                  class="text-decoration-none text-dak fw-500"
                  :to="`/tenant/workflow/add?workflowId=${item.id}&fw=true`"
                >
                  {{ item.isActive ? "Yes" : "No" }}
                </router-link>
              </div>
            </template>

            <template v-slot:action="{ item }">
              <el-dropdown trigger="click">
                <el-icon>
                  <MoreFilled />
                </el-icon>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item>
                      <router-link
                        :to="`/tenant/workflow/add?workflowId=${item.id}&fw=true`"
                        class="text-color"
                        >Edit</router-link
                      >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div
                        @click.prevent="confirmDelete(item.id)"
                        class="text-color"
                      >
                        Delete
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </template>
          </TableSearch>
        </div>
        <div v-else v-loading="loading">
          <div v-if="!loading" class="font-weight-700">
            No workflow created yet
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import workflowFunctions from "../utlity/workflow_service";
import axios from "@/gateway/backendapi";
import router from "../../../router";
import TableSearch from "@/components/table/TableSearch";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  components: {
    TableSearch,
  },

  setup() {
    const loading = ref(false);
    const workflows = ref([]);
    const searchText = ref("");

    // const previousPage = () => {
    //   router.push("/tenant/settings");
    // };

    const headers = ref([
      { name: "NAME", value: "name" },
      { name: "ACTIVE", value: "isActive" },
      { name: "ACTION", value: "action" },
    ]);

    const filteredData = computed(() => {
      if (!searchText.value.trim()) {
        return workflows.value;
      }
      return workflows.value.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchText.value.toLowerCase())
      );
    });

    const getWorkflows = async () => {
      try {
        loading.value = true;
        const { returnObject: data } = await workflowFunctions.getWorkflows();
        workflows.value = data;
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    };
    getWorkflows();
    const handleSearchTextUpdate = (newValue) => {
      searchText.value = newValue;
    };

    const deleteWorkflow = (id) => {
      if (id) {
        loading.value = true;
        axios.delete(`/api/workflow?id=${id}`).then((res) => {
          workflows.value = workflows.value.filter((i) => i.id !== id);
          loading.value = false;
          ElNotification({
            type: "success",
            message: "Workflow deleted successfully",
            showClose: true,
            duration: 5000,
          });
        });
      }
    };

    const confirmDelete = (id) => {
      ElMessageBox.confirm(
        "Are you sure you want to proceed?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => {
          deleteWorkflow(id);
        })
        .catch(() => {
          loading.value = false;
          ElNotification({
            type: "info",
            message: "Rejected",
            duration: 5000,
          });
        });
    };

    return {
      handleSearchTextUpdate,
      filteredData,
      searchText,
      workflows,
      // previousPage,
      loading,
      confirmDelete,
      headers,
    };
  },
};
</script>

<style scoped>
.text-color {
  color: #212529;
  text-decoration: none;
}

.text-color:hover {
  color: #007bff;
}
</style>
